
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^47(125|229)$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
